/**
 * IntentIcon Component
 * Icon for SetupIntentPage
 */

import setupIntentIconImage from '../../assets/images/setupIntentIcon.png'
import setupIntentIconImage2x from '../../assets/images/setupIntentIcon@2x.png'

interface IntentIconProps {
  size?: number
  className?: string
}

export const IntentIcon = ({ size = 100, className = '' }: IntentIconProps) => (
  <img
    src={setupIntentIconImage}
    srcSet={`${setupIntentIconImage} 1x, ${setupIntentIconImage2x} 2x`}
    alt="Intent Icon"
    className={className}
    style={{
      width: size,
      height: size,
    }}
  />
)
